import { email } from 'vuelidate/lib/validators';

export default {
    email
};